import React, { useState, useEffect } from "react";
import "./NavBar.css";
import { Link } from "react-router-dom";

interface NavBarProps {
  isOpaque?: boolean;
}

interface NavItem {
  name: string;
  href?: string;
  subItems?: Array<{ name: string; href: string }>;
}

const NavBar: React.FC<NavBarProps> = ({ isOpaque = false }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState<string | null>(null);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileMenuOpen(false);
      setActiveDropdown(null);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Element;
      if (!target.closest(".dropdown")) {
        setActiveDropdown(null);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  const navItems: NavItem[] = [
    { name: "Home", href: "/" },
    // { name: "Aves", href: "/#aves" },
    { name: "Ilustrações", href: "/ilustracoes" },
    // { name: "Para Colorir", href: "/#para-colorir" },
    { name: "Fotos", href: "/fotos" },
    { name: "Sobre", href: "/sobre" },
    // {
    //   name: "Artistas",
    //   subItems: [
    //     { name: "Ilustradores", href: "/#ilustradores" },
    //     { name: "Fotógrafos", href: "/#fotografos" },
    //   ],
    // },
    { name: "TCCs", href: "/projetos" },

    { name: "Cadernos", href: "/cadernos" },
  ];

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const toggleDropdown = (itemName: string) => {
    setActiveDropdown(activeDropdown === itemName ? null : itemName);
  };

  const handleItemClick = () => {
    setIsMobileMenuOpen(false);
    setActiveDropdown(null);
  };

  const handleDropdownMouseEnter = (itemName: string) => {
    setActiveDropdown(itemName);
  };

  const handleDropdownMouseLeave = () => {
    setActiveDropdown(null);
  };

  const handleNavbarMouseLeave = () => {
    // Close any open dropdown when leaving the entire navbar
    setActiveDropdown(null);
  };

  return (
    <nav
      className={`navbar ${isOpaque ? "navbar-opaque" : "navbar-transparent"}`}
      onMouseLeave={handleNavbarMouseLeave}
    >
      <div className="navbar-container">
        {/* Logo */}
        <Link to="/" style={{ textDecoration: "none" }}>
          <div className="navbar-brand">
            <img src="/texture/blob.png" alt="LaRC" className="larc-icon" />

            <h1>LaRC</h1>
          </div>
        </Link>

        {/* Menu */}
        <div
          className={`navbar-menu ${
            isMobileMenuOpen ? "navbar-menu-open" : ""
          }`}
        >
          <ul className="navbar-nav">
            {navItems.map((item, index) => (
              <li key={index} className="navbar-item">
                {item.subItems ? (
                  <div
                    className="dropdown"
                    onMouseEnter={() => handleDropdownMouseEnter(item.name)}
                    onMouseLeave={handleDropdownMouseLeave}
                  >
                    <button
                      className="navbar-link dropdown-toggle"
                      onClick={() => toggleDropdown(item.name)}
                    >
                      {item.name}
                    </button>
                    <ul
                      className={`dropdown-menu ${
                        activeDropdown === item.name ? "dropdown-menu-open" : ""
                      }`}
                    >
                      {item.subItems.map((subItem, subIndex) => (
                        <li key={subIndex} className="dropdown-item">
                          <Link
                            to={subItem.href}
                            className="dropdown-link"
                            onClick={handleItemClick}
                          >
                            {subItem.name}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                ) : (
                  <Link
                    to={item.href!}
                    className="navbar-link"
                    onClick={handleItemClick}
                  >
                    {item.name}
                  </Link>
                )}
              </li>
            ))}
          </ul>
        </div>

        {/* Botão mobile */}
        <button
          className={`hamburger ${isMobileMenuOpen ? "hamburger-open" : ""}`}
          onClick={toggleMobileMenu}
          aria-label="Toggle menu"
        >
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
        </button>
      </div>
    </nav>
  );
};

export default NavBar;
